module.exports = __webpack_public_path__ + "static/media/helicopter.af982ed8.svg";